import {mintUploadTarget, uploadToStorage, useRegisterEvidence} from '@/hooks/sgsst/evidencias/use-evidence'

const ESTANDAR_SOLICITUD = '3.1.3'

type Registrar = ReturnType<typeof useRegisterEvidence>

/** El registro devuelve la lista entera y sin `object_key`: el tamaño desempata homónimos subidos a la vez. */
export async function subirEvidencia313(
  businessId: string,
  registrar: Registrar,
  file: File,
  onProgress: (pct: number) => void
): Promise<{id: string; filename: string} | null> {
  const target = await mintUploadTarget(businessId, file)
  await uploadToStorage(target, file, onProgress)
  const respuesta = await registrar.mutateAsync({
    standard_code: ESTANDAR_SOLICITUD,
    object_key: target.object_key,
    filename: file.name,
    content_type: file.type,
    size_bytes: file.size,
    employee_ids: [],
  })
  const nueva = respuesta.data.items
    .filter((fila) => fila.filename === file.name && fila.size_bytes === file.size)
    .sort((a, b) => (a.uploaded_at ?? '').localeCompare(b.uploaded_at ?? ''))
    .at(-1)
  return nueva ? {id: nueva.id, filename: file.name} : null
}
